/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import*as r from"react";import{stylesheetSingleton as n}from"./singleton.js";var t=function(){var t=n();return function(n,o){r.useEffect((function(){return t.add(n),function(){t.remove()}}),[n&&o])}};export{t as styleHookSingleton};
//# sourceMappingURL=hook.js.map
